// Utility function to set favicon dynamically using environment variable
export const setFavicon = () => {
    const cloudFrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;
    if (cloudFrontUrl) {
        const favicon = document.getElementById('favicon') || document.querySelector('link[rel="icon"]');
        if (favicon) {
            favicon.href = `${cloudFrontUrl}/assets/images/favicon.ico`;
        }
    }
};
